import { useTranslation } from "react-i18next";
import { InputBlock } from "../ui/Input";
import { integerValidate } from "../../helpers/validate";
import { v4 as uuidv4 } from "uuid";
import SlideButton from "../ui/SlideButton";
import {
	instrNameCol1,
	instrNameCol2,
	instrNameCol3,
	instrNameCol4
} from "../../helpers/dictionary/users";
import {getNameColumnTypeStaff} from "../../helpers/tools";
import React, {useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {Button} from "../ui/Button";
import {Colors} from "../theme";
import DarkCard from "../card/DarkCard";
import PopupForm from "../ui/PopupForm";
import {getStaffAPI, saveStaffAPI} from "../../services/api/projectCurrent";
import { Link } from "react-router-dom";
import RedHeader from "../ui/RedBgTitleHeader";
import LightCard from "../card/LightCard";
import { TxtTitles } from "../../helpers/breadCrumbs";


function   Staff() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [staff, setStaff] = useState();
	const params = useParams();
	const [popup, setPopup] = useState({show: false, title: '', variant: 'error', message: ''});
	const [changeState, setChangeState] = useState([]);
	const location = useLocation()
	const [returnPath] = useState(sessionStorage.getItem('project-current-return'));

	useEffect(() => {
		const get_staff = async () => {
			const response = await getStaffAPI(params.id);
			console.log("init data", response);
			if (response.status === 200) {
				setStaff(response.data);
			} else navigate("/network-error")
		}
		get_staff();
		sessionStorage.removeItem('project-current-return');
	},[])

	useEffect(() => {
		return () => sessionStorage.removeItem('project-current-return')
	}, [location])

	const InstrumentsView = name => {
		if (name in staff) {
			const instrItem = {...staff[name]}

			return (
				<InputBlock
					key={uuidv4()}
					fieldName={instrItem}
					handler={changeHandler}
					t={t}
				/>
			);
		}
		return null;
	};

	const changeHandler = (el, fieldName) => {
		const changeStateCopy = structuredClone(changeState)
		const instrument_change_state = changeStateCopy.findIndex(el => el.instrument === fieldName);
		let isDelete = 1
		if (instrument_change_state === -1) isDelete = 0
		changeStateCopy.splice(instrument_change_state, isDelete, {instrument: fieldName, count: el})
		setChangeState(changeStateCopy)

		if (fieldName === 'conductor') {
			setStaff({...staff, conductor: el})
			return
		}
		// wybierz oznaczenie typu kolumny
		const instrTypeName = getNameColumnTypeStaff(fieldName)

		if (integerValidate(el)) {
			const staffCopy = structuredClone(staff)
			const currentEntry = staffCopy[fieldName]
			currentEntry.value = el
			currentEntry.type = instrTypeName

			const newEntry = {
				...staff,
				[fieldName]: currentEntry,
			}
			setStaff(newEntry);
		}
	}

	const changeHandlerOthers = (val) => {
		setStaff({...staff, others: val})
		const changeStateCopy = structuredClone(changeState)
		const instrument_change_state = changeStateCopy.findIndex(el => el.instrument === 'others');
		let isDelete = 1
		if (instrument_change_state === -1) isDelete = 0
		changeStateCopy.splice(instrument_change_state, isDelete, {instrument: 'others', count: val})
		setChangeState(changeStateCopy)
	}

	const changeKzmProject = (value) => {
		setStaff({...staff, kzmProject: value})
		setChangeState([...changeState, {instrument: 'kzmProject', count: value}])
	}

	const buttonHandler = async (opt) => {
		if (opt === 'save') {
			setPopup({
				show: true,
				variant: "editF",
				title: t("popups.current_projects.save_data_title"),
				message: t("popups.current_projects.save_data_message"),
				type: "formular",
				leftBtn: t("common.button.save"),
				rightBtn: t("common.button.cancel"),
			});
			return
		}
		else if (returnPath) navigate(returnPath);
		navigate("/projects/current/" + params.id)
	}

	const handlePopup = async (opt) => {
		if (opt.type === 'save') {
			const response = await saveStaffAPI(params.id, changeState)
			if (response.status === 201) {
				setPopup({
					show: true,
					variant: "success",
					title: t("popups.save_data.title"),
					message: t("popups.save_data.message"),
					type: "formular",
					okBtn: t("common.button.ok"),
				});
			}
			return
		}
		else {
			if (returnPath) navigate(returnPath);
			navigate("/projects/current/"+params.id)
		}
	}

	if (!staff) return null;
	
	const totalStaffSum = Object.keys(staff).reduce((sum, key) => {
        const value = Number(staff[key].value); // Convert the string to a number
        return !isNaN(value) && value > 0 ? sum + value : sum; // Add value to sum if it's a valid number and greater than 0
    }, 0);

	return (<>
		{popup.show
			? <PopupForm
				handlePopup={handlePopup}
				variant={popup.variant}
				title={t(popup.title)}
				message={t(popup.message)}
				leftBtn={popup.leftBtn}
				rightBtn={popup.rightBtn}
				okBtn={popup.okBtn}
				// context={popup.context}
			/>
			: <>
				<DarkCard classNames='mb-3 row'>
					<p className="m-0 p-0 breadcrumbs">
						<span className="txt">{t("menu.projects",{ ns: 'menu' })}</span>&#8201;&#9656;&#8201;
						<Link to={'/projects/currents-list'}>{t("menu.current_projects",{ ns: 'menu' })}</Link>&#8201;&#9656;&#8201;
						<Link to={'/projects/current/'+params.id}>{t("breadcrumbs.project_title")} P{params.id}</Link>&#8201;&#9656;&#8201;
						<span className="txt">{t("common.button.edit_staff")}</span>
					</p>
				</DarkCard>
				<DarkCard classNames='mb-3 row'>
					<TxtTitles>{t("project.project_name_title")}</TxtTitles>
					<h1 className='mb-3 mt-0 p-0' style={{marginTop: '-5px'}}>
						{location.state.datasetName}
					</h1>

					<LightCard>
						<RedHeader title={t('project.staff_title')+` (${totalStaffSum})`}/>
						<div className='row px-2'>
							<div className='col-sm-6 col-md-3 d-flex flex-column'>
								{instrNameCol1.map(el => InstrumentsView(el))}
							</div>
							<div className='col-sm-6 col-md-3 d-flex flex-column'>
								{instrNameCol2.map(el => InstrumentsView(el))}
							</div>
							<div className='col-sm-6 col-md-3 d-flex flex-column'>
								{instrNameCol3.map(el => InstrumentsView(el))}
							</div>
							<div className='col-sm-6 col-md-3 d-flex flex-column'>
								{instrNameCol4.map(el => InstrumentsView(el))}

								<InputBlock
									key={uuidv4()}
									fieldName={{name: "Others", value: staff.others, label: "effectif.others_mus"}}
									handler={changeHandlerOthers}
									t={t}
								/>

								<InputBlock
									key={uuidv4()}
									fieldName={{name: "conductor", value: staff.conductor, label: "effectif.Conductor"}}
									handler={changeHandler}
									t={t}
								/>
							</div>
						</div>
					
						<div className='row mt-2 mb-3 px-2'>
							<div>{t("events.kzm_participating")}</div>
							<SlideButton
								type='yesNo'
								val={staff.kzmProject}
								setVal={val => changeKzmProject(val)}
							/>
						</div>
					</LightCard>

					<div className="mt-3">
						<Button
							className='me-4'
							variant='round'
							style={{backgroundColor: `${Colors.green}`}}
							name='save'
							onClick={() => buttonHandler('save')}>
							{t("common.button.save")}
						</Button>

						<Button
							className='me-4'
							variant='round'
							styling="bordered"
							name='cancel'
							onClick={() => buttonHandler('cancel')}>
							{t("common.button.cancel")}
						</Button>
					</div>
				</DarkCard>
	</>}</>);
}
export default Staff;
